import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import React from 'react';
import ArrowIcon from '../../../../../assets/svg/home-notifications/ArrowIcon';
import { Text } from '../../../../../react-components/Text';

interface NotificationPillProps {
  notification: {
    icon: React.ReactElement;
    titleIntlId: string;
    titleIntlValues?: Record<string, string | number | Function>;
    messageIntlId: string;
    messageIntlValues?: Record<string, string | number | Function>;
    onClick?: () => void;
    hasRightArrow?: boolean;
  };
  containerStyles?: React.CSSProperties;
  titleStyles?: React.CSSProperties;
  messageStyles?: React.CSSProperties;
  arrowStyles?: { color?: string; style?: React.CSSProperties };
}

export const NotificationPill = ({
  children,
  notification,
  containerStyles = {},
  titleStyles = {},
  messageStyles = {},
  arrowStyles = {},
}: React.PropsWithChildren<NotificationPillProps>) => {
  return (
    <Grid
      container
      direction="column"
      onClick={notification.onClick}
      alignItems="flex-start"
      justifyContent="center"
      wrap="nowrap"
      style={{
        padding: `16px`,
        minHeight: `80px`,
        borderRadius: `10px`,
        background: `#40686780`,
        ...containerStyles,
      }}
    >
      <Grid container direction="row" flexWrap="nowrap" alignItems="center">
        <Grid container direction="column" gap="4px" alignItems="flex-start" wrap="nowrap">
          <Grid item container direction="row" gap="6px" alignItems="flex-start" wrap="nowrap">
            {notification.icon}

            <Text
              variant="body-medium"
              intlId={notification.titleIntlId}
              intlValues={notification.titleIntlValues}
              style={{
                color: RoutalPalette.neutral02n,
                fontWeight: 500,
                ...titleStyles,
              }}
            />
          </Grid>

          <Grid item>
            <Text
              variant="small"
              intlId={notification.messageIntlId}
              intlValues={notification.messageIntlValues}
              style={{
                color: RoutalPalette.neutral20,
                fontWeight: 400,
                ...messageStyles,
              }}
            />
          </Grid>
        </Grid>

        {notification.hasRightArrow && (
          <Grid>
            <ArrowIcon color={arrowStyles.color} style={{ height: `24px`, width: `24px`, ...arrowStyles.style }} />
          </Grid>
        )}
      </Grid>
      {children}
    </Grid>
  );
};
